import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  userAvatar: {
    position: 'relative',
    overflow: 'visible',
    backgroundColor: theme.vars.palette.transparent.a10,
    color: theme.vars.palette.transparent.a50
  }
}));

export default useStyles;
